import { OptionSelector } from "../../components/option-selector/option-selector";
import commonUtil from "../../util/common-utils";
import { userEditForm } from "./user-edit-form";
import { UserEditListener } from "./user-edit-listener";

interface PrefectureOptionLike {
    value?: string;
    translate?: string;
}

interface MasterDataEditControllerLike {
    modal: HTMLElement | null;
    _userPrefecturePendingValue?: string;
}

export class UserEditRender {
    public static renderUserPrefectureDisplayForMasterDataEdit(
        controller: MasterDataEditControllerLike,
        value: unknown,
        option: PrefectureOptionLike | null,
        label: string,
    ): void {
        if (!(controller.modal instanceof HTMLElement)) return;
        const pickerEl = userEditForm.getPrefecturePicker(controller.modal);
        const displayEl = userEditForm.getPrefectureDisplay(controller.modal);
        const clearEl = userEditForm.getPrefectureClearButton(controller.modal);
        if (!(displayEl instanceof HTMLElement)) return;

        const hasValue = String(value ?? "").trim() !== "";
        const translateKey = String(option?.translate ?? "").trim();

        displayEl.innerHTML = hasValue
            ? `<span class="picker-chip"><span class="picker-chip__label"${
                  translateKey ? ` data-translate="${commonUtil.escapeHtml(translateKey)}"` : ""
              }>${commonUtil.escapeHtml(label)}</span></span>`
            : '<span class="input-placeholder">-</span>';

        if (pickerEl instanceof HTMLElement) {
            pickerEl.classList.toggle("has-items", hasValue);
        }

        if (clearEl instanceof HTMLElement) {
            clearEl.style.display = hasValue ? "" : "none";
        }
    }

    public static renderUserPrefectureModalListForMasterDataEdit(
        controller: MasterDataEditControllerLike,
        options: PrefectureOptionLike[],
        activeValue: unknown,
        translateLabel: (entry: PrefectureOptionLike) => string,
    ): void {
        if (!(controller.modal instanceof HTMLElement)) return;
        const listEl = userEditForm.getPrefectureModalList(controller.modal);
        if (!(listEl instanceof HTMLElement)) return;

        if (!Array.isArray(options) || options.length === 0) {
            listEl.innerHTML = '<div class="search-menu-results__state">No prefecture found</div>';
            return;
        }

        const rowsHtml = options
            .map((entry) => {
                const value = String(entry?.value ?? "").trim();
                const translate = String(entry?.translate ?? "").trim();
                const checked = value === String(activeValue ?? "").trim() ? " checked" : "";
                const label = String(translateLabel(entry) ?? "").trim();

                return `<label class="option-label"><input type="radio" name="users-prefecture-modal-choice" value="${commonUtil.escapeHtml(
                    value,
                )}"${checked}><span class="option-text"${
                    translate ? ` data-translate="${commonUtil.escapeHtml(translate)}"` : ""
                }>${commonUtil.escapeHtml(label)}</span></label>`;
            })
            .join("");

        listEl.innerHTML = `<div class="option-selector option-selector--picker js-option-selector" role="radiogroup">${rowsHtml}</div>`;

        userEditForm.getPrefectureChoiceInputs(listEl).forEach((radio) => {
            UserEditListener.bindPrefectureChoiceChange(radio, () => {
                controller._userPrefecturePendingValue = radio.value;
            });
        });

        OptionSelector.init(listEl);
    }
}
